exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--default[data-v-c27ba51a]{color:#fff!important}", ""]);

// exports
